<template>
  <div id="app">
  		<v-header></v-header>
	    <v-content></v-content>
	    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from './components/header/header';
import Content from './components/content/content';
import Footer from './components/footer/footer';


export default {
  components:{
    'v-header':Header,
    'v-content':Content,
    'v-footer':Footer,
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?4bb938b6